var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.281 15.5c.777 0 1.406-.63 1.406-1.406v-1.406h1.407c.776 0 1.406-.63 1.406-1.407V1.906C15.5 1.13 14.87.5 14.094.5H4.719c-.777 0-1.407.63-1.407 1.406v1.406H1.906C1.13 3.312.5 3.942.5 4.72v9.375c0 .776.63 1.406 1.406 1.406zm2.637-4.219H4.895a.176.176 0 0 1-.176-.176V2.082c0-.097.079-.176.176-.176h9.023c.097 0 .176.079.176.176v9.023a.176.176 0 0 1-.176.176m-2.813 2.813H2.082a.176.176 0 0 1-.176-.176V4.895c0-.097.079-.176.176-.176h1.23v6.562c0 .777.63 1.406 1.407 1.406h6.562v1.23a.176.176 0 0 1-.176.177",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;